

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AddressDto } from '@/api';
import { getModule } from 'vuex-module-decorators';
import UserStore from '@/stores/user/user.store';

@Component
export default class AddressShow extends Vue {
  @Prop({required: true})
  private address!: AddressDto;

  private userStore = getModule(UserStore, this.$store);

  private isStandardBillingAddress(address: AddressDto): boolean {
    return this.userStore.currentUser?.billingAddress?.id === address.id;
  }

  private isStandardDeliveryAddress(address: AddressDto): boolean {
    return this.userStore.currentUser?.deliveryAddress?.id === address.id;
  }
}
